import { GlobalDispatchEvent } from './SmartTypes';

const globalReducer = (state: any, action: GlobalDispatchEvent) => {
    switch (action.type) {
        case 'INITIALIZE_APP':
            state.domain = action.payload.domain;
            state.userNameForSearch = action.payload.userNameForSearch;
            state.appSettings = action.payload.appSettings;
            state.isLoading = false;
            state.loginMode = action.payload.loginMode;
            break;
        case 'SET_USER_NAME_FOR_SEARCH':
            state.userNameForSearch = action.payload;
            break;
        // case 'SET_AUTH_DATA':
        //     state.authData = action.payload;
        //     break;
        // case 'SET_USER_NAME_FOR_SEARCH':
        //     state.userNameForSearch = action.payload;
        //     break;
        // case 'SET_DOMAIN_DATA':
        //     state.domain = action.payload;
        //     break;
        // case 'SET_APP_SETTINGS':
        //     state.appSettings = action.payload;
        //     break;
        // case 'SET_LOADING_DONE':
        //     state.isLoading = false;
        //     break;
        case 'SET_USER_STATUS':
            state.userStatusCode = action.payload;
            break;
        case 'SET_USER_CONTEXT':
            state.context = action.payload;
            break;
        case 'SET_SELECTED_INSTITUTE':
            state.context.set('SELECTED_INSTITUTE', action.payload);
            break;
        case 'SET_TOAST_DATA':
            state.toastData = action.payload;
            break;
        case 'SET_LOGIN_MODE':
            state.loginMode = action.payload;
            break;
        case 'SET_DIRECTORY_FILTERS_CACHE':
            state.directoryFiltersCache = action.payload;
            break;
        case 'CLEAR_DIRECTORY_FILTERS_CACHE':
            state.directoryFiltersCache = undefined;
            break;
        default:
            throw new Error();
    }
};

export default globalReducer;
